import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Rentals',
		url: '/rentals',
		icon: 'tags',
	},
];

export default class Rental extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
	}

	render() {
		let {name} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name,
				url: `/rentals/${this.props.id}`,
				icon: 'file-text-o',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Rental" value="details"/>
					<Tab label="Change Log" value="logs"/>
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.Rental
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						baseUrl={this.props.baseUrl}
						scannedCode={this.props.scannedCode}
						updateName={this.updateName}
					/>
				</div>
				{this.state.tab === 'logs' &&
				<Collections.LogsRentals
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
			</div>
		);
	}
};